<template>
  <li :data-tooltip="tooltip" class="bqX row-action" @click="onClick"><svg-icon :icon-class="iconClass"/></li>
</template>

<script>
export default {
  props: ['item', 'tooltip', 'iconClass', 'action'],

  methods: {
    onClick () {
      this.action && this.action(this.item)
      this.$emit('click', this.item)
    }
  }
}
</script>

<style scoped>
  .bqX {
    height: 20px;
    opacity: .54;
    width: 20px;
    opacity: .54;
    align-items: center;
    border: none;
    display: inline-flex;
    justify-content: center;
    outline: none;
    position: relative;
    z-index: 0;
    cursor: pointer;
    list-style: none;
    margin: 0 6px;
   }

  .bqX .svg-icon {
    width: 1rem;
    height: 1rem;
  }

  .brq {
    /*background-image: url(https://www.gstatic.com/images/icons/material/system/1x/archive_black_20dp.png);*/
    /*background-position: center;*/
    /*background-repeat: no-repeat;*/
    /*background-size: 20px;*/
  }

  .bqX:not(.pW)::before {
    content: '';
    display: block;
    opacity: 0;
    position: absolute;
    transition-duration: .15s;
    transition-timing-function: cubic-bezier(0.4,0.0,0.2,1);
    z-index: -1;
    bottom: -10px;
    left: -10px;
    right: -10px;
    top: -10px;
    background: none;
    border-radius: 50%;
    box-sizing: border-box;
    transform: scale(0);
    transition-property: transform,opacity;
    bottom: -10px;
    left: -10px;
    right: -10px;
    top: -10px;
  }
  .bqX:not(.pW):hover::before {
    background-color: rgba(32,33,36,0.059);
    border: none;
    box-shadow: none;
    opacity: 1;
    transform: scale(1);
  }
  .bqX:not(.pW):hover, .bqX:not(.pW):focus, .bqX:not(.pW):active {
    opacity: 1;
    z-index: 100;
  }

  .bqX:not(.pW):after {
    content: '';
    height: 200%;
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
  }
</style>



// WEBPACK FOOTER //
// src/components/meridian/RowAction.vue